import React, { useCallback } from 'react';
import { css } from '@emotion/css';

import useScreen from '@lyearn/core/hooks/useScreen';
import { ArrowIosLeftOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { DeprecatedIconButton } from '@lyearn/ui';
import useNavigation from '@/hooks/useNavigation';

const defaultArrowClassName = css`
  height: 3.2rem !important;
  width: 3.2rem !important;
`;

const NavigateBack: React.FC<{
  fillColorToken?: string;
  className?: string;
  isDisabled?: boolean;
  arrowClassName?: string;
  onClickBack?: () => void;
  to?: string;
  replace?: boolean;
}> = (props) => {
  const {
    fillColorToken = 'link-internal',
    className,
    isDisabled,
    arrowClassName,
    onClickBack,
    to,
    replace,
  } = props;
  const navigation = useNavigation();
  const { isMobile } = useScreen();
  const onClick = useCallback(() => {
    onClickBack?.();
    if (to) {
      if (replace) {
        navigation.replace(to);
        return;
      }
      navigation.push(to);
      return;
    }
    navigation.back();
  }, [navigation, onClickBack, replace, to]);

  return (
    <DeprecatedIconButton
      appearance="inverse"
      className={cn('hidden ms-4 xl:shadow-01 xs:flex', className)}
      size="large"
      variant={isMobile ? 'ghost' : 'filled'}
      onClick={isDisabled ? undefined : onClick}>
      <ArrowIosLeftOutline
        className={arrowClassName ?? defaultArrowClassName}
        fillColorToken={fillColorToken}
        height={32}
        width={32}
      />
    </DeprecatedIconButton>
  );
};

export default NavigateBack;
